export default "__VITE_ASSET__DtzFIggR__"